import { Utils } from '@therealmanage/ciranet-ui-common';

export class UserDashboardItemDetailResultDto {
  communityId: number;
  customerId: string;
  propertyAddress: string;
  value: string;

  // Transient
  activityDate: Date;

  get isNumber(): boolean {
    return Utils.isValidNumber(parseFloat(this.value));
  }
}
